import styled from "styled-components";

export const ItemListContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  padding: 12px;    
  border: 1px solid  #BABABA;
  width: 100%;
  border-radius: 8px;
`;

export const ItemWrapper = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
`;

export const ItemActionsWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 8px;
`;

export const ItemLeftWrapper = styled.div`
  display: flex;
  flex-direction: row;
  flex: 1;
  gap: 24px;
`;

export const ItemInfoWrapper = styled.div`
  display: flex;
  flex-direction: row;
  flex: 1;
  gap: 24px;
`;

export const ItemTitleWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: start;
  align-items: center;
  gap: 16px;
  width: 250px;
`;

export const ColumnWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: start;
  gap: 4px;
  width: 120px;
  
   & > * {
    align-self: flex-start;
  }
`;
export const ContentColapsibleWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 8px;
  padding: 16px 24px;
  align-items: center;
`;

export const RepairsOrdersSectionContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  justify-content: space-between;
  gap: 8px;
  padding: 8px 0px;
  border-bottom: 1px solid #F2F2F2;
`;

export const RepairsOrdersSectionRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
`;
export const RepairsOrdersSectionRowLeft = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 4px;
`;

 